type DataTypeObj = {
  table: string;
  id: number;
  notIds: number[];
  title: string;
  description: string;
  apiEndpoint: string;
  displayColumns: string[];
  tabs?: Array<{ key: string; label: string }>;
};
export const DATATYPES: Record<string, DataTypeObj> = {
  // Disabled array for now
  array: {
    table: "Schema",
    id: 1,
    notIds: [],
    title: "Arrays",
    description: "Arrays are a collection of data types.",
    apiEndpoint: "/api/array",
    displayColumns: ["Name", "Description"],
    tabs: [
      { key: "children", label: "Children" },
      { key: "parent", label: "Parent" },
      { key: "schema", label: "Schema" },
      { key: "visualized", label: "Visualized" },
    ],
  },
  thing: {
    table: "Schema",
    id: 21,
    notIds: [],
    title: "Things",
    description: "Things are the primary data type in the system.",
    apiEndpoint: "/api/thing",
    displayColumns: ["Name", "Description"],
    tabs: [
      { key: "children", label: "Children" },
      { key: "parent", label: "Parent" },
      { key: "schema", label: "Schema" },
      { key: "visualized", label: "Visualized" },
    ],
  },
  property: {
    table: "Schema",
    id: 0,
    notIds: [1, 21], // Not 1 or 21
    title: "Properties",
    description: "A property, used to indicate attributes and relationships of some Thing; equivalent to rdf:Property.",
    apiEndpoint: "/api/property",
    displayColumns: ["Name", "Description", "Nullable", "DataType"],
    tabs: [
      { key: "children", label: "Children" },
      { key: "parent", label: "Parent" },
      { key: "schema", label: "Schema" },
      { key: "visualized", label: "Visualized" },
    ],
  },
  datatype: {
    table: "Data Types",
    id: 25,
    notIds: [],
    title: "DataType",
    description: "Data Types are the schema for properties.",
    apiEndpoint: "/api/dataType",
    displayColumns: ["Name", "Description"],
    tabs: [{ key: "structure", label: "Structure" }],
  },

  // ---- Character / Prefix /Suffix ----
  character: {
    table: "Characters",
    id: 22,
    notIds: [],
    title: "Character",
    description:
      "The use of characters can be updated dynamically as the needs of the schema change. These two " +
      "portions of the schema are under less onerous change management rules than the other portions. Therefore, " +
      "coverage of them here is abbreviated.",
    apiEndpoint: "/api/character",
    displayColumns: ["Char", "Unicode", "Dec", "Hex", "Binary", "HTML", "Description"],
    tabs: [],
  },
  prefix: {
    table: "Prefixes",
    id: 22,
    notIds: [],
    title: "Name Prefix",
    description: "This list shows prefixes used for a Person.",
    apiEndpoint: "/api/prefix",
    displayColumns: ["Name", "Abbreviation"],
    tabs: [],
  },
  suffix: {
    table: "Suffixes",
    id: 22,
    notIds: [],
    title: "Name Suffix",
    description: "This list shows suffixes used for a Person.",
    apiEndpoint: "/api/suffix",
    displayColumns: ["Name", "Abbreviation"],
    tabs: [],
  },
};
